import { WhatsappShareButton } from "react-share";
//import WA from "../assets/icons8-share.svg";

function QrImg({ data }) {

  const qrUrlWithBase = process.env.REACT_APP_BASE_URL + "getQr/" + btoa(data?.id);
  
  return (
    <div className="flex-shrink-0 snap-center items-center justify-center relative">
      <img src={data.qrUrl} alt="qr" className="w-[277px] h-[428px] " />
      <WhatsappShareButton url={qrUrlWithBase}  title={`Please find your QR code for ${data?.type} for ${decodeURIComponent(data?.date)}`}>
        <img
          src="https://cdn3.iconfinder.com/data/icons/virtual-notebook/16/button_share-512.png"
          alt="wa-icon"
          className="absolute right-14 bottom-32 h-[25px] w-[25px] rounded-md"
        />
      </WhatsappShareButton>
    </div>
  );
}

export default QrImg;
